export interface UserFlowInitRequest {
  flowType: FlowType;
  accountId: string | null;
}

export interface UserFlowInitResponse {
  token: string;
  userFlowId: string;
}

export enum FlowType {
  ADD_BANK = 'ADD_BANK',
  ON_DEMAND = 'ON_DEMAND',
  EXTEND_CONSENT = 'EXTEND_CONSENT',
  DELETE_INFO_SHARING_CONSENT = 'DELETE_INFO_SHARING_CONSENT',
}

export interface UserFlowStateResponse {
  status: UserFlowStateStatus;
  step: UserFlowStateStep;
  flowType: FlowType;
  infoSharingConsentId: string;
}

export enum UserFlowStateStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum UserFlowStateStep {
  SYNC_INITIALIZED = 'SYNC_INITIALIZED',
  SYNC_STARTED = 'SYNC_STARTED',
  BANK_AUTH_STARTED = 'BANK_AUTH_STARTED',
  BANK_AUTH_COMPLETED = 'BANK_AUTH_COMPLETED',
  DATA_DOWNLOADED = 'DATA_DOWNLOADED',
  SYNC_COMPLETED = 'SYNC_COMPLETED',
  INFO_SHARING_CONSENT_GIVEN = 'INFO_SHARING_CONSENT_GIVEN',
}
